import React, { useState, useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
import { adminMainUrl } from '../../../../Config';
import { getJobOrderList } from '../../../../Redux/action/Joborder/JoborderAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { DDMMMYYYYformateDate } from '../../../../HelperFunctions';
import axios from 'axios';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import { getHrmsBranchList } from '../../../../Redux/action/Organisation/Branch/BranchAction';

const JobOrderMasterCCAI = ({ title, trans_mode, service_type, impexp, accessedModules, accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState([]);
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();
    const q = location.pathname.slice(1) + location.search;

    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search);
        const savedPage = params.get("page");
        return savedPage ? Number(savedPage) : 1;
    });

    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderList(token, user_id, trans_mode, service_type, impexp, queryParams.get("page") ?? 1, queryString));
            dispatch(getHrmsBranchList(token, user_id));
        } else {
            toast.error("Please login to continue.")
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.search]);

    const {
        loadingJobOrderList,
        JobOrderList,
        JobOrderListError,
        JobOrderListTotalPages,
        JobOrderListTotalData
    } = useSelector(state => state?.JoborderReducer);

    let { HrmsBranchList } = useSelector(state => state?.BranchReducer || {});
    const filterBranchList = HrmsBranchList && Array.isArray(HrmsBranchList) ? HrmsBranchList.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    })) : [];

    let { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer || {});
    const hasFilterPermission = sidebarPermissionHRMSData?.role_id == sidebarPermissionHRMSData?.user_id;

    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_text: params.get("search_text") || "",
            trans_mode: params.get("trans_mode") || "",
            trans_type: params.get("trans_type") || "",
            branch_id: params.get("branch_id") || "",
        };
    };

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
        },
    });

    const resetFilters = () => {
        try {
            formik.setValues({
                search_text: "",
                trans_mode: "",
                trans_type: "",
                branch_id: "",
            });
            let url = location.pathname;
            if (url) {
                navigate(url);
            }
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        if (loadingJobOrderList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (JobOrderList) {
            let arr = [];
            JobOrderList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: ((currentPage - 1) * 10) + i + 1,
                    Joborderno: val?.job_order_unique_no, // Ensure date formatting as neede
                    Trackingno: val?.tracking_no,
                    Date: DDMMMYYYYformateDate(val?.createdAt),
                    Transportmode: val?.trans_mode,
                    Transporttype: val?.trans_type,
                    shipment_type: val?.cc_id ?
                        "Console Shipment" :
                        val?.ff_id ?
                            val?.ff_type == "Direct MAWB" ?
                                "Direct" :
                                val.ff_type == "Console HAWB" ?
                                    "Console" :
                                    "-"
                            : "-"
                    ,
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {accessedPermission.includes("edit_job_order") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/edit/${btoa(val?.id)}`) }} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit Job Order
                                    </div>}
                                    {service_type == "custom_clearance" ?
                                        val.cc_id ?
                                            accessedPermission.includes("ai_edit_custom_clearance") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                            </div>
                                            :
                                            accessedPermission.includes("ai_add_custom_clearance") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? "sea" : "air"}/${impexp == "importer" ? "import" : "export"}/add?j_id=${btoa(val.id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                            </div>
                                        :
                                        service_type == "freight_forwarding" ?
                                            val.ff_id ?
                                                val.ff_type == "Console HAWB" ?
                                                    <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/console/hawb/edit/${btoa(val.ff_id)}`) }} >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit  Console HAWB
                                                    </div> :
                                                    val.ff_type == "Direct MAWB" ?
                                                        <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/direct/mawb/edit/${btoa(val.ff_id)}`) }} >
                                                            <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Direct MAWB
                                                        </div> :
                                                        <div className="dropdown-item cursor-pointer">
                                                            Network Error
                                                        </div>
                                                :
                                                <div className="dropdown-item cursor-pointer"
                                                    onClick={() => {
                                                        navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/add?j_id=${btoa(val.id)}`)
                                                    }}
                                                >
                                                    <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSource(arr);

        }
    }, [loadingJobOrderList, JobOrderList])





    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Joborder No.", dataIndex: "Joborderno", key: "Joborderno" },
        { title: "Tracking No.", dataIndex: "Trackingno", key: "Trackingno" },
        { title: "Date", dataIndex: "Date", key: "Date" },
        { title: "Transport Mode", dataIndex: "Transportmode", key: "Transportmode" },
        { title: "Transport Type", dataIndex: "Transporttype", key: "Transporttype" },
        { title: "Shipment Type", dataIndex: "shipment_type", key: "shipment_type" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];



    const handleCheckQuotationCustomClearance = (id) => {
        try {
            const config = {
                headers: {
                    'auth-token': Cookies.get('token'),
                    'user_id': Cookies.get('flexichain_user_id'),
                }
            }

            axios.post(`${adminMainUrl}/api/customClearance/check-cc-exists`, { job_order_id: id }, config)
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.data == true) {
                            navigate(`/flexichain/job-order/freight-forwarding/${trans_mode == "Sea" ? "sea" : "air"}/${impexp == "importer" ? "import" : "export"}/add?j_id=${btoa(id)}`)
                        } else {
                            toast.error("Please add custom clearance details first.")
                        }
                    } else {
                        let msg = 'Internal server error!';
                        if (res.data && res.data.msg) {
                            msg = res.data.msg
                        }
                        toast.error(msg);
                    }
                }).catch((error) => {
                    console.log(error);
                    toast.error(error.message);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }




    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title ?? "Job Order List"}<span className="count-title">{JobOrderListTotalData ?? "0"}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-4 text-end">
                                                    <div className="head-icons">
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            data-bs-original-title="Collapse"
                                                            id="collapse-header"
                                                        >
                                                            <i className="ti ti-chevrons-up" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <div className="card">

                                    <div className="card-body">

                                        {/* Filter */}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    <div className="icon-form mb-3 mb-sm-0 mx-1">
                                                        <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Job Order/Quotation No."
                                                            name='search_text'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.search_text}
                                                        />
                                                    </div>
                                                    {!trans_mode && <div className="mb-3 mb-sm-0 mx-1">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name='trans_mode'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_mode}
                                                        >
                                                            <option value="">-Select Transport Mode-</option>
                                                            <option value="Air">Air</option>
                                                            <option value="Sea">Sea</option>
                                                        </select>
                                                    </div>}
                                                    {!service_type && <div className="mb-3 mb-sm-0 mx-1">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name='trans_type'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_type}
                                                        >
                                                            <option value="">-Select Transport Type-</option>
                                                            <option value="Import">Import</option>
                                                            <option value="Export">Export</option>
                                                        </select>
                                                    </div>}

                                                </div>
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    {hasFilterPermission && (
                                                        <div className="form-sorts dropdown me-2">
                                                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                                                                <i className="ti ti-filter-share" /> Filter
                                                            </a>
                                                            <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                                                <div className="filter-set-view">
                                                                    <div className="filter-set-head">
                                                                        <h4><i className="ti ti-filter-share" /> Filter</h4>
                                                                    </div>
                                                                    <table className="content-table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td><label>BRANCH</label></td>
                                                                                <td className="input_box_filter">
                                                                                    <Select
                                                                                        className="ms-2"
                                                                                        classNamePrefix="react-select"
                                                                                        placeholder="Select Branch"
                                                                                        options={filterBranchList}
                                                                                        isClearable
                                                                                        styles={{
                                                                                            container: (base) => ({ ...base, width: '100%', minWidth: '220px' }),
                                                                                            control: (base) => ({ ...base, minHeight: '33px', height: '32px', fontSize: '12px' }),
                                                                                            valueContainer: (base) => ({ ...base, height: '32px', padding: '0 6px' }),
                                                                                            indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                                                                            menu: (base) => ({ ...base, fontSize: '12px' }),
                                                                                            option: (base) => ({ ...base, fontSize: '12px', padding: '4px 8px' }),
                                                                                        }}
                                                                                        value={filterBranchList.find(opt => opt.value == formik.values.branch_id) || null}
                                                                                        onChange={(selected) => formik.setFieldValue("branch_id", selected ? selected.value : "")}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <div className="filter-reset-btns">
                                                                        <div className="row">
                                                                            <div className="col-6">
                                                                                <a href="javascript:void(0);" className="btn btn-light w-100" onClick={resetFilters}>Reset</a>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <button type="submit" className="btn btn-primary w-100">Filter</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <button type='submit' className="btn btn-primary me-2">
                                                        Search
                                                    </button>
                                                    <button type="button" onClick={resetFilters}
                                                        className='btn btn-light me-2'
                                                    >
                                                        Clear
                                                    </button>
                                                    {service_type == 'custom_clearance' ?
                                                        (trans_mode && impexp && (
                                                            (trans_mode == "Air" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_air_import")) ||
                                                            (trans_mode == "Air" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_air_export")) ||
                                                            (trans_mode == "Sea" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_sea_export")) ||
                                                            (trans_mode == "Sea" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_sea_import"))
                                                        )) ?
                                                            <div
                                                                className="btn btn-primary cursor-pointer me-2"
                                                                onClick={() => {
                                                                    navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? 'sea' : 'air'}/${impexp == "exporter" ? 'export' : 'import'}/add`)
                                                                }}
                                                            >
                                                                <i className="ti ti-square-rounded-plus me-2" />
                                                                Add Custom Clearance
                                                            </div> : null
                                                        :
                                                        service_type == 'freight_forwarding' ?
                                                            <div
                                                                className="btn btn-primary cursor-pointer me-2"
                                                                // onClick={handleAddShow}
                                                                onClick={() => { navigate("/flexichain/job-order/freight-forwarding/shipment/air/export/add") }}
                                                            >
                                                                <i className="ti ti-square-rounded-plus me-2" />
                                                                Add Freight Forwarding
                                                            </div>
                                                            :
                                                            accessedPermission.includes("create_job_order") && <div
                                                                className="btn btn-primary cursor-pointer me-2"
                                                                // onClick={handleAddShow}
                                                                onClick={() => { navigate("/flexichain/job-order/add") }}
                                                            >
                                                                <i className="ti ti-square-rounded-plus me-2" />
                                                                Add Job Order
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                            <div className="table-responsive custom-table">
                                                <Table className="table datanew dataTable no-footer" pagination={false}
                                                    dataSource={dataSource} columns={columns} />
                                            </div>
                                            {JobOrderList?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={JobOrderListTotalPages || 1}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div>}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>


    )
}

export default JobOrderMasterCCAI